import React, {useState, useEffect, useContext } from 'react';
import { IonModal, IonGrid, IonRow, IonCol, IonButton, IonSlides, IonSlide, IonContent, IonHeader, IonFooter } from '@ionic/react';

import { Auth_MerchantID_context } from '../../../storeState/auth_merchantID_context';

import '../css/clientCss.css';
import { ViewAttachement_ImageModal } from '../../zInternal_Features/merchant/components/Modal_ViewAttachement_Image';

export function HistoryOrderDetailsModal(props) {


    let authClient_context = useContext(Auth_MerchantID_context);


    const [acctID, setAcctID ] = useState(authClient_context.acctID);
    const [schema, setSchemaName] = useState(authClient_context.schema);
    let [sessionID, setSessionID ] = useState(authClient_context.sessionID);
    let [baseURL, setBaseURL ] = useState(authClient_context.baseURL);

    let [viewEstimateDetailData, setViewEstimateDetailData] = useState([]);


    let [estimateID, setEstimateID] = useState(null);
    let [totalAmount, setTotalAmount] = useState(null);
    let [paymentType, setPaymentType] = useState(null);
    let [imageAttachement, setImageAttachement] = useState(null);
    let [viewAttachementModal, setViewAttachemntModal] = useState(false);



   //getOccupiedRoomDetailData(instant_checkInRoomID) {
    useEffect(() => {

        //alert('In Occupied Detailed Data');
        //alert(props.openModal);

        if(props.openModal == true)
        {


            const requestOptions = {
                method: 'POST',
                //credentials: 'include',
                headers: {
                    'Accept': 'text/html, application/json',
                    'content-type': 'application/json',
                    //'cookie': 'cookie',
                },
                body: JSON.stringify({
                    Tracker: '74101_view_orderDetails_history',
                    user: acctID,
                    xEstimateID: props.data.estimateID,
                    sessionID: sessionID,
    
                }),
            }

            
            fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
            .then(res => res.text())
            .then(res => {

                let rows = res.toString().split('~~~');


                for (let rownum = 0; rownum < rows.length - 1; ++rownum)
                {
                    let cols = rows[rownum].split('|');

                    setEstimateID(cols[0]);

                    setViewEstimateDetailData((prevAvailableRooms) => {
                        return prevAvailableRooms.concat({
                            estimateID: cols[0],
                            customerFirstName: cols[1],
                            customerLastName: cols[2],
                            customerMobileNumber: cols[3],
                            estimateDescription: new Date(cols[4]).toISOString().substr(0, 10),
                            estimateLatitude: parseFloat(cols[5]).toFixed(2),
                            estimateLongitude: cols[6],
                            dateLogged: cols[7],
                            estimateImage1: cols[8],
                            status: cols[9],
                        })
                    });
                } 
            })
        }
    }, [props.openModal]);


    function conver_to_consult()
    {
        const requestOptions = {
            method: 'POST',
            //credentials: 'include',
            headers: {
                'Accept': 'text/html, application/json',
                'content-type': 'application/json',
                //'cookie': 'cookie',
            },
            body: JSON.stringify({
                Tracker: '74101_convert_to_consult',
                user: acctID,
                xEstimateID: props.data.estimateID,
                sessionID: sessionID,

            }),
        }

        
        fetch(baseURL+'proService_merchantAcct_argsjqApp', requestOptions)
        .then(res => res.text())
        .then(res => {

            alert(res);
        })
    }

    function viewEstimateAttachmentHandler(event) {

        //alert('In viewEstimateInvoiceHandler');
        //alert(event);
        //alert(event[0]);
        //alert(event[3]);
        //alert(event[4]);
        //alert(event[5]);

        // setTotalAmount(event[3]);
        // setPaymentType(event[4]);
        setImageAttachement(event[1]);

        setViewAttachemntModal(event[0]);

        //setRoomID(event[1]);
        //setRoomSalePrice(event[2]);
    }

    function closeModalHandler() {

        setViewEstimateDetailData([]);
        props.closeModal(false);
    }

    return (
        <React.Fragment>
        {props.openModal == true ?
        (
        <IonModal isOpen={ props.openModal }>
        <IonHeader className='grid_checkInHeader'>
            <IonGrid class='gridModalTopInfo'>
                    <IonRow>
                        <IonCol> Estimate ID</IonCol>
                        <IonCol> {props.data.estimateID} </IonCol>
                    </IonRow>
            </IonGrid>
        </IonHeader>
        <div  style={{display: 'inline-block'}}>
            {viewEstimateDetailData.map((detailData) =>   {
            return (
            <IonGrid class='gridText'>
                <IonRow class='gridResultHeaders'>
                    <IonCol class='gridResultColumns'>Category</IonCol>
                    <IonCol class='gridResultColumns'>Value</IonCol>
                    <IonCol class='gridResultColumns'>Action</IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol class='gridResultHeaders'>Customer Name</IonCol>
                    <IonCol class='gridResultColumns'>{detailData.customerFirstName} {detailData.customerLastName}</IonCol>
                    <IonCol class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol class='gridResultHeaders'>Customer Phone</IonCol>
                    <IonCol class='gridResultColumns'>{detailData.supplierPhoneNumber}</IonCol>
                    <IonCol class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol class='gridResultHeaders'>Customer Location</IonCol>
                    <IonCol class='gridResultColumns'>{detailData.estimateLatitude} {detailData.estimateLongitude}</IonCol>
                    <IonCol class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> View </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol class='gridResultHeaders'>Date Logged</IonCol>
                    <IonCol class='gridResultColumns'>{detailData.dateLogged}</IonCol>
                    <IonCol class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol class='gridResultHeaders'>Description</IonCol>
                    <IonCol style={{fontSize: 'small'}}>
                        <textarea cols="50" rows="10" placeholder='Request Description' required> {detailData.estimateDescription}</textarea>
                    </IonCol>
                    <IonCol class='gridResultColumns'>
                        <IonButton class='gridResultColumnButton'> - </IonButton>
                    </IonCol>
                </IonRow>
                <IonRow class='gridResultBody'>
                    <IonCol class='gridResultHeaders'>Attachment</IonCol>
                    <IonCol class='gridResultColumns'>{'Estimate Attachment'}</IonCol>
                    <IonCol class='gridResultColumns'>
                        <ViewAttachement_ImageModal openModal={ viewAttachementModal } closeModal={() => setViewAttachemntModal(false)} data={{
                                                fileLocation: detailData.attachment, 
                                                }}></ViewAttachement_ImageModal>

                        <IonButton className='appListButton' onClick={() => viewEstimateAttachmentHandler([true, detailData.attachment])}> View </IonButton>

                    </IonCol>
                </IonRow>
            </IonGrid>
                    )
                }
            )}
        </div>


        <IonFooter className='modal_footer_button_center'>
            <IonButton onClick={closeModalHandler}> Close </IonButton>
        </IonFooter>

    </IonModal>) : null}
    </React.Fragment>
    )
}